import Settings from 'core/Settings';
class EnergyBar extends Phaser.Sprite {

  constructor(game) {
    super(game, 0, 0);
    this.createBar();
  }

  createBar() {
    this.fill = this.game.add.graphics(585,28);
    this.fill.beginFill(0xFFFFFF);
    this.fill.lineTo(185, -5);
    this.fill.lineTo(186, 40);
    this.fill.lineTo(0, 30);
    this.fill.lineTo(0, 0);
    this.fill.endFill();

    this.masker = this.game.add.graphics(585,28);
    this.masker.beginFill(0xFF0000);
    this.masker.lineTo(190, -5);
    this.masker.lineTo(190, 40);
    this.masker.lineTo(0, 30);
    this.masker.lineTo(0, 0);
    this.masker.endFill();

    this.fill.mask = this.masker;

    this.barframe = this.game.add.sprite(580, 20, "bar");

    this.origin = this.fill.x; // used to measure when game over has happened
  }

  update() {
    this.fill.x -= Settings.HEALTH_DEPLETION_RATE;

    if(this.fill.x < (this.origin - this.fill.width)) {
      this.game.state.start('GameOverState');
    }

    if(this.fill.x > 530)
      this.fill.tint = 0x339706;
    else if(this.fill.x < 530 && this.fill.x > 450)
      this.fill.tint = 0xFFFF00;
    else
      this.fill.tint = 0xFF0000;
  }

  onPickup() {
    this.fill.x += Settings.PICKUP_AMOUNT;

    if(this.fill.x > this.origin)
      this.fill.x = this.origin;
  }

  onHurt() {
    this.fill.x -= Settings.HURT_AMOUNT;
  }
}

export default EnergyBar;
